import { combineReducers } from 'redux';
import * as reducers from './reducers';

export const rangeInput = combineReducers(reducers);
